import { render, staticRenderFns } from "./ProjectFilter.vue?vue&type=template&id=461f1989"
import script from "./ProjectFilter.vue?vue&type=script&lang=ts"
export * from "./ProjectFilter.vue?vue&type=script&lang=ts"
import style0 from "./ProjectFilter.vue?vue&type=style&index=0&id=461f1989&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports